import rightImg from "images/aboutsection.png";
import rightImg2 from "images/image2.png";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import SectionGridFeaturePlaces from "./SectionGridFeaturePlaces";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import SectionHero3 from "components/SectionHero/SectionHero3";
import SectionHero from "containers/PageAbout/SectionHero";
import SectionClientSay from "components/SectionClientSay/SectionClientSay";
import { globalJson } from "global/global_json";
import { useEffect } from "react";
import SectionHero2 from "containers/PageAbout/SectionHero2";
import WhyLevel305 from "components/why305/why305";
import ReadytoDrive from "./ReadytoDrive";
import readytodrive from "images/readytodrive.png";
import RentalPolicies from "components/RentalPolicies/RentalPolicies";
import WhyRentSection from "components/WhyRentSection/WhyRentSection";
import Banner from "containers/BannerSection/Banner";

function PageHome3() {
  useEffect(() => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user");
  }, []);
  return (
    <>
      <div className="nc-PageHome3 relative overflow-hidden">
        {/* GLASSMOPHIN */}
        <BgGlassmorphism />
        {/* <DownloadLink /> */}

        {/* SECTION HERO */}
        {/* <div className="container relative lg:pb-16 lg:pt-8 md:pt-0 sm:pt-0 px-0 md:pb-0 sm:pb-0 "> */}
        <SectionHero3 className="" />

        {/* </div> */}
        <div className="container relative py-24">
          <SectionGridFeaturePlaces />
        </div>
        <div className="container relative" style={{ padding: "0px" }}>
          <div className="container py-16  space-y-16 lg:space-y-28 ">
            <SectionHero
              rightImg={rightImg}
              heading="Experience, Elegance, Excellence"
              btnText="Read More About Us"
              subHeading={globalJson?.about_us_para}
            />
          </div>
          <div className="container relative py-16">
            <Banner />
          </div>
          <div className="container relative py-16">
            <SectionClientSay uniqueClassName="PageAbout_" />
          </div>
        </div>
            <div
            className="bg-[url('images/bg-img.png')] bg-cover bg-center bg-no-repeat w-full min-h-screen"
            >
            <div className="py-16">
              <WhyRentSection />
            </div>
            </div>

        <div className="container relative py-16">
          <RentalPolicies />
        </div>
      </div>
    </>
  );
}

export default PageHome3;
